import { useFormContext } from "react-hook-form";
import CotationCard from "./CotationCard";
import ShieldIcon from "../../../../assets/icons/shield.svg?react";
import { CotationFormData } from "../../../../types/forms/home/cotationFormData.form";
import StyledSwitch from "../../../../components/ui/customs/StyledSwitch";

const InsuranceCard = () => {
  const { control } = useFormContext<CotationFormData>();

  return (
    <CotationCard>
      <div className="flex flex-1 flex-row gap-4">
        <ShieldIcon className="text-zinc-900" />
        <div className="flex flex-1 flex-col">
          <p className="font-semibold">Assurance</p>
          <p>Ajoutez une assurance complémentaire pour couvrir la totalité de la marchandise</p>
        </div>
        <StyledSwitch name="insurance" control={control} />
      </div>
    </CotationCard>
  );
};

export default InsuranceCard;
